import facility from './facility'

export default {
  namespaced: true,
  modules: {
    facility
  }
}
